import React, {useEffect} from 'react';
import Modal, {useModal} from '../../../../components/Modal';
import styled from 'styled-components';
import {Redirect} from 'react-router-dom';

const ModalContentContainer = styled.div(
  props => `
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`,
);

const CounterContainer = styled.div(
  props => `
  padding: ${props.theme.spacing.large} 0
  font-size: ${props.theme.font.large};
`,
);

const WhatHappenedModalToSRP: React.FC<{
  title: string;
  redirect?: {
    shouldRedirect: boolean;
    to: string;
    after?: number;
    displayText?: string;
  };
  children?: React.ReactNode;
}> = ({title, redirect = {}, children}) => {
  const {shouldRedirect, to, after = 5, displayText} = redirect;

  const shouldDefinitelyRedirect = !!shouldRedirect && !!to;

  const [willRedirectAfter, setWillRedirectAfter] = React.useState(after);

  const redirectNow = willRedirectAfter === 0;

  useEffect(() => {
    if (!shouldDefinitelyRedirect) {
      return;
    }

    const timerId = setInterval(() => {
      setWillRedirectAfter(prev => prev - 1);
    }, 1000);

    return () => {
      if (timerId) {
        clearInterval(timerId);
      }
    };
  }, [shouldDefinitelyRedirect, after]);

  return (
    <Modal
      isOpen={true}
      modalStyles={{
        height: '40vh',
        width: '50vw',
      }}
      hideCloseButton
    >
      {shouldDefinitelyRedirect && redirectNow && <Redirect to={to} />}

      <ModalContentContainer>
        <h2>{title}</h2>

        {shouldDefinitelyRedirect && (
          <CounterContainer>
            Redirecting {displayText ? ` you to ${displayText}` : ''} after {willRedirectAfter}
          </CounterContainer>
        )}
      </ModalContentContainer>

      {children && {children}}
    </Modal>
  );
};

export default WhatHappenedModalToSRP;
